require('./bootstrap');

// Plugins
import 'JBPlugin/in-viewport';
import 'JBPlugin/slick';
import 'JBPlugin/scroll-to';
import 'JBPlugin/jquery.autocomplete.min';
import 'JBPlugin/jquery.are-you-sure';
import 'JBPlugin/ays-beforeunload-shim';
import '@fancyapps/fancybox';
import 'flatpickr';

// Section scripts
import 'JBSrc/blog-cards';
import 'JBSrc/calendars';
import 'JBSrc/infinity-pagination';
import 'JBSrc/event-print';
import 'JBSrc/event-form';
import 'JBSrc/event-search-form';
import 'JBSrc/event-start-form';
import 'JBSrc/filter';
import 'JBSrc/form-inputs';
import 'JBSrc/get-support-search';
import 'JBSrc/header';
import 'JBSrc/manager-actions';
import 'JBSrc/modals';
import 'JBSrc/scroll-to-anchor';
import 'JBSrc/tabs';
import 'JBSrc/validation';
import 'JBSrc/header-filter';
import 'JBSrc/in-view';
import 'JBSrc/notification-counts';
import 'JBSrc/global';
import 'JBSrc/masonry-cards';
import 'JBSrc/gtm-events';
import 'JBSrc/discount-off-campus-filter';

// Partials
import 'Partial/header';
import 'Partial/carousel';
import 'Partial/shuffle_gallery';
import 'Partial/map';
import 'Partial/bard/accordion';
import 'Partial/page_scroll_nav';
import 'Partial/page_header';
import 'Partial/home_banner';
